export const aboutData = {
	video: {
		firstTitle: 'BRAND NEW APP TO BLOW YOUR MIND',
		title: 'We’ve made a life that will change you',
		subTitle: 'We are here to listen from you deliver exellence',
		txt:
			'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod temp or incididunt ut labore et dolore magna aliqua. Ut enim ad minim.',
		video: 'https://www.youtube.com/embed/TCMnrssX1NE',
		modal: {
			title: 'How To Get Started',
			txt:
				'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.',
		},
	},

	specification: {
		heading: {
			title: 'Top Courses That are open for Students',
			subTitle: 'Who are in extremely love with eco friendly system.',
		},

		leftDataList: [
			{
				title: 'High Performance',
				txt:
					'Lorem ipsum dolor sit amet, consectetur adipisic ing elit, seddo eiusmod tempor incid.idunt ut labore et dolore magna aliqua.',
			},
			{
				title: 'High Performance',
				txt:
					'Lorem ipsum dolor sit amet, consectetur adipisic ing elit, seddo eiusmod tempor incid.idunt ut labore et dolore magna aliqua.',
			},
		],

		rightDataList: [
			{
				title: 'High Performance',
				txt:
					'Lorem ipsum dolor sit amet, consectetur adipisic ing elit, seddo eiusmod tempor incid.idunt ut labore et dolore magna aliqua.',
			},
			{
				title: 'High Performance',
				txt:
					'Lorem ipsum dolor sit amet, consectetur adipisic ing elit, seddo eiusmod tempor incid.idunt ut labore et dolore magna aliqua.',
			},
		],
	},

	details: {
		title: 'Globally Connected by Large Network',
		subTitle: 'We are here to listen from you deliver exellence',
		txt:
			'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.',
		modal: {
			title: 'Here are the full details',
			txt:
				'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
		},
	},
};
